import { render, staticRenderFns } from "./ultimos_usuario.vue?vue&type=template&id=0ea34b6a&scoped=true&"
import script from "./ultimos_usuario.vue?vue&type=script&lang=js&"
export * from "./ultimos_usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea34b6a",
  null
  
)

export default component.exports